<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('materialtype_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-materialtype-show">
      <v-row>
        <v-col md="5" v-if="item">
          <v-img
            class = "ml-5 ma-2"
            height="250"
            max-width="250"
            lazy-src="@/assets/imagenotfound.png"
            :key="componentKey"
            :src="imageurlItem"
          >
            <ImageForm
              ref="updateForm"
              :item="item"
              v-if="userHasAccess('materialtype_edit')"
            />
              <v-btn
                color="secondary"
                small
                absolute
                bottom
                right
                @click="downloadItem()"
              >
                <v-icon>mdi-download-circle</v-icon>
              </v-btn>
          </v-img>
          <graphRadar class="ml-5" :materialtype="item"></graphRadar>
        </v-col>
      <v-col md="7">


      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.material.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('profile.material.public') }}</strong></td>
              <td>
                <span v-if="item.public" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.description') }}</strong></td>
              <td>
                                    {{ item['description'] }}
              </td>
              <td><strong>{{ $t('profile.material.comment') }}</strong></td>
              <td>
                                    {{ item['comment'] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-row class="ml-5 mt-5 mb-5">
        <h2><v-icon class="mr-2 ">mdi-pencil-ruler</v-icon>{{$t('profile.material.measures')}}</h2>
      </v-row>
      <v-simple-table class="" >
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.material.tempresistance') }}</strong></td>
              <td>
                                    {{ item['tempResistance'] }}
              </td>
              <td><strong>{{ $t('profile.material.chemicalresistance') }}</strong></td>
              <td>
                                    {{ item['chemicalResistance'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.uvresistance') }}</strong></td>
              <td>
                                    {{ item['uvResistance'] }}
              </td>
              <td><strong>{{ $t('profile.material.mecaresistance') }}</strong></td>
              <td>
                                    {{ item['mecaResistance'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.material.abrasionresistance') }}</strong></td>
              <td>
                                    {{ item['abrasionResistance'] }}
              </td>
              <td><strong>{{ $t('profile.material.tractionresistance') }}</strong></td>
              <td>
                                    {{ item['tractionResistance'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.complexity') }}</strong></td>
              <td>
                                    {{ item['complexity'] }}
              </td>
              <td><strong>{{ $t('profile.material.density') }}</strong></td>
              <td>
                                    {{ item['density'] }}
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.elongation') }}</strong></td>
              <td>
                                    {{ item['elongation'] }}
              </td>
              <td><strong>{{ $t('profile.material.tenacity') }}</strong></td>
              <td>
                                    {{ item['tenacity'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.cost') }}</strong></td>
              <td>
                                    {{ item['cost'] }}
              </td>
              <td><strong>{{ $t('profile.material.electrical') }}</strong></td>
              <td>
                                    {{ item['electrical'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.thermal') }}</strong></td>
              <td>
                                    {{ item['thermal'] }}
              </td>
              <td><strong>{{ $t('profile.material.dielectric') }}</strong></td>
              <td>
                                    {{ item['dielectric'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.hardnessshoretype') }}</strong></td>
              <td>
                                  <span v-if="item['hardnessShoreType']"> {{ item['hardnessShoreType'].name }}</span>
              </td>
              <td><strong>{{ $t('profile.material.hardnessshore') }}</strong></td>
              <td>
                                    {{ item['hardnessShore'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.material.hardness') }}</strong></td>
              <td>
                                    {{ item['hardness'] }}
              </td>
              <td><strong>{{ $t('profile.material.tempfusion') }}</strong></td>
              <td>
                                    {{ item['tempFusion'] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>

    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import FileMixin from '../../mixins/FileMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import graphRadar from '../../components/materialtype/graphRadar';
import ImageForm from '../../components/ImageForm.vue';

const servicePrefix = 'MaterialType';

export default {
  name: 'MaterialTypeShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      graphRadar,
      ImageForm
  },
  data: () => ({
    filter: '250x250',
  }),
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('materialtype', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialtype', ['find'])
  },
  methods: {
    ...mapActions('materialtype', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
